import React from "react";
import { AutoSuggestItem } from "../search/AutoSuggestResponse";
import { getBusinessTitleFromSuggestItem } from "../search/suggestionsPicker/utils/peoplePickerUtils";

import styles from "./person-renderer-styles.module.css";

interface EmployeeProps {
  employee: AutoSuggestItem;
  showTitle?: boolean;
}

type PersonRendererProps = EmployeeProps;

const PersonRenderer: React.FC<PersonRendererProps> = ({
  employee,
  showTitle = false,
}): JSX.Element => {
  return (
    <div>
      <div className={styles["headshot-cropper-medium"]}>
        <img
          src={`https://badgephotos.corp.amazon.com/?uid=${employee.urlId}`}
          className={styles["headshot"]}
        />
      </div>
      <div>
        <div
          className={
            showTitle
              ? styles["person-text-top-row"]
              : styles["person-text-center-row"]
          }
        >{`${employee.title}`}</div>
        {showTitle && (
          <div>
            <br />
            <div className={styles["person-text-bottom-row"]}>
              {`${getBusinessTitleFromSuggestItem(employee)}, ${
                employee.detail
              }`}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default PersonRenderer;
